var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGeofenceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 427318577"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.5 4.7125V12.2875C14.38 12.265 14.2525 12.25 14.125 12.25C13.09 12.25 12.25 13.09 12.25 14.125C12.25 14.2525 12.265 14.38 12.2875 14.5H4.7125C4.735 14.38 4.75 14.2525 4.75 14.125C4.75 13.09 3.91 12.25 2.875 12.25C2.7475 12.25 2.62 12.265 2.5 12.2875V4.7125C2.62 4.735 2.7475 4.75 2.875 4.75C3.91 4.75 4.75 3.91 4.75 2.875C4.75 2.7475 4.735 2.62 4.7125 2.5H12.2875C12.265 2.62 12.25 2.7475 12.25 2.875C12.25 3.91 13.09 4.75 14.125 4.75C14.2525 4.75 14.38 4.735 14.5 4.7125Z",
    stroke: "#8899B4",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.75 2.875C4.75 3.91 3.91 4.75 2.875 4.75C2.7475 4.75 2.62 4.735 2.5 4.7125C1.645 4.54 1 3.7825 1 2.875C1 1.84 1.84 1 2.875 1C3.7825 1 4.54 1.645 4.7125 2.5C4.735 2.62 4.75 2.7475 4.75 2.875Z",
    stroke: "#8899B4",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16 2.875C16 3.7825 15.355 4.54 14.5 4.7125C14.38 4.735 14.2525 4.75 14.125 4.75C13.09 4.75 12.25 3.91 12.25 2.875C12.25 2.7475 12.265 2.62 12.2875 2.5C12.46 1.645 13.2175 1 14.125 1C15.16 1 16 1.84 16 2.875Z",
    stroke: "#8899B4",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M4.75 14.125C4.75 14.2525 4.735 14.38 4.7125 14.5C4.54 15.355 3.7825 16 2.875 16C1.84 16 1 15.16 1 14.125C1 13.2175 1.645 12.46 2.5 12.2875C2.62 12.265 2.7475 12.25 2.875 12.25C3.91 12.25 4.75 13.09 4.75 14.125Z",
    stroke: "#8899B4",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M16 14.125C16 15.16 15.16 16 14.125 16C13.2175 16 12.46 15.355 12.2875 14.5C12.265 14.38 12.25 14.2525 12.25 14.125C12.25 13.09 13.09 12.25 14.125 12.25C14.2525 12.25 14.38 12.265 14.5 12.2875C15.355 12.46 16 13.2175 16 14.125Z",
    stroke: "#8899B4",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeofenceIcon);
export default __webpack_public_path__ + "static/media/geofence-icon.84ec7e9d696065cdbef2e35fb6f0f182.svg";
export { ForwardRef as ReactComponent };